"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = void 0;
const redux_observable_1 = require("redux-observable");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const Actions = require("../../actions/info/buildInfo");
const ActionTypes = require("../../actionTypes/info/buildInfo");
const errorHandling_1 = require("../../utils/errorHandling");
const fetch = (action$, _store, { ajax, baseUrl }) => {
    const getUrl = () => `${baseUrl}api/status/build-info`;
    const ajaxOptions = () => ({ method: 'GET', url: getUrl() });
    const onSuccess = (res) => (0, rxjs_1.of)(Actions.success(res.response));
    const onFailure = (error) => (0, rxjs_1.of)(Actions.failure((0, errorHandling_1.parseAjaxErrorResponse)(error)));
    const ajaxCall = () => ajax(ajaxOptions()).pipe((0, operators_1.mergeMap)(onSuccess), (0, operators_1.catchError)(onFailure));
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.REQUEST), (0, operators_1.mergeMap)(ajaxCall));
};
exports.fetch = fetch;
//# sourceMappingURL=buildInfo.js.map